<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/user/list" color="blue">取消回上一頁</v-btn>
    </div>

    <v-form @submit.prevent="submit()" v-model="valid">
      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">基本資料</p>
          
          <v-text-field
            v-model="form.email"
            :rules="[formRules.required, formRules.email]"
            label="帳號信箱"
            outlined
          ></v-text-field>
          <v-text-field v-model="form.username" :rules="[formRules.required]" label="使用者名稱" outlined></v-text-field>
          <v-select
            v-model="form.role_id"
            :items="mappingRole"
            item-text="text"
            item-value="value"
            :rules="[formRules.required]"
            label="權限角色"
            placeholder="權限角色"
            outlined
          ></v-select>
          <v-select
            v-model="form.view_cash_transactions"
            :items="viewStatus"
            item-text="text"
            item-value="value"
            label="瀏覽現金交易"
            placeholder="瀏覽現金交易"
            outlined
            v-if="form.role_id == 300"
          ></v-select>
          <v-select
            v-model="form.status"
            :items="mappingStatus"
            item-text="text"
            item-value="value"
            :rules="[formRules.required]"
            label="帳號狀態"
            placeholder="帳號狀態"
            outlined
          ></v-select>
        </v-card-text>
      </v-card>

      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">機器權限</p>

          <v-simple-table>
            <tbody>
              <tr
                v-for="machine in machines"
                @click="checkbox(machine.machine_id)"
                :style="{ cursor: $hasHigherPermission ? 'default' : 'pointer' }"
              >
                <td>
                  <v-checkbox
                    v-model="form.machine_ids"
                    :value="machine.machine_id"
                    color="teal"
                    @click.prevent
                  ></v-checkbox>
                </td>
                <td>{{ machine.serial_number }}</td>
                <td>{{ machine.name }}</td>
                <td>{{ machine.address }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>

      <div class="text-center mb-6">
        <v-btn to="/user/list" color="blue" class="mr-3">取消回上一頁</v-btn>
        <v-btn type="submit" :disabled="!valid" color="orange">確認新增</v-btn>
      </div>
    </v-form>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import DataMixin from "@/mixins/Data";

import machineApi from "@/api/machine";
import userApi from "@/api/user";

export default {
  components: {},

  mixins: [DataMixin],

  props: [],
  data() {
    return {
      machines: [],

      valid: false,

      form: {
        username: "",
        email: "",
        role_id: 0,
        view_cash_transactions: 0,
        status: "active",
        machine_ids: []
      }
    };
  },

  computed: {
    $hasHigherPermission() {
      return [0, 300].indexOf(this.form.role_id) === -1;
    }
  },
  watch: {
    "form.role_id": function(val) {
      this.form.machine_ids = [];

      if (val === 200) {
        this.machines.forEach(machine => {
          this.form.machine_ids.push(machine.machine_id);
        });
      }
    }
  },
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    checkbox(id) {
      if (this.$hasHigherPermission) {
        return;
      }

      const machineIds = this.form.machine_ids;
      const idx = machineIds.indexOf(id);
      if (idx !== -1) {
        machineIds.splice(idx, 1);
      } else {
        machineIds.push(id);
      }
    },

    submit() {
      const machine_ids = this.form.machine_ids;
      if (!machine_ids.length) {
        machine_ids.push(0);
      }

      userApi
        .create(this.form)
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });
          } else {
            this.$router.push("/user/list");
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    machineApi
      .getAll()
      .then(res => {
        this.machines = res.machines;
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
